/* Opt-in editor links become click-to-load previews. No media request before click. */
(function () {
    if (!window.HTMLDialogElement) return;
    const links = document.querySelectorAll('a[data-gameplay-preview]');
    links.forEach(link => {
        let url;
        try { url = new URL(link.href); } catch (error) { return; }
        if (url.protocol !== 'https:') return;
        let youtubeId;
        if (url.hostname === 'youtu.be') youtubeId = url.pathname.slice(1);
        if (['youtube.com', 'www.youtube.com'].includes(url.hostname)) youtubeId = url.searchParams.get('v');
        const youtube = youtubeId && /^[\w-]{11}$/.test(youtubeId);
        const video = /\.(mp4|webm)$/i.test(url.pathname);
        if (!youtube && !video) return;
        link.setAttribute('aria-haspopup', 'dialog');
        link.addEventListener('click', event => {
            if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
            event.preventDefault();
            const dialog = document.createElement('dialog');
            dialog.className = 'studio-preview-dialog';
            dialog.setAttribute('aria-label', link.dataset.previewLabel || 'Gameplay preview');
            const close = document.createElement('button');
            close.className = 'studio-preview-close';
            close.type = 'button';
            close.textContent = link.dataset.closeLabel || 'Close preview';
            const media = document.createElement(youtube ? 'iframe' : 'video');
            if (youtube) {
                media.title = dialog.getAttribute('aria-label');
                media.src = 'https://www.youtube-nocookie.com/embed/' + youtubeId;
                media.allow = 'fullscreen; picture-in-picture';
                media.referrerPolicy = 'strict-origin-when-cross-origin';
            } else {
                media.controls = true;
                media.playsInline = true;
                media.preload = 'metadata';
                media.src = url.href;
            }
            close.addEventListener('click', () => dialog.close());
            dialog.addEventListener('click', e => { if (e.target === dialog) dialog.close(); });
            dialog.addEventListener('close', () => {
                if (video) media.pause();
                media.removeAttribute('src');
                dialog.remove();
                link.focus({preventScroll: true});
            }, {once: true});
            dialog.append(close, media);
            document.body.append(dialog);
            dialog.showModal();
            close.focus();
        });
    });
}());
